import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M14.5837 1.66666C14.9001 1.66666 15.1616 1.90179 15.203 2.20686L15.2087 2.29166V3.33333H17.5003C17.9606 3.33333 18.3337 3.70643 18.3337 4.16666V17.5C18.3337 17.9602 17.9606 18.3333 17.5003 18.3333H2.50033C2.04009 18.3333 1.66699 17.9602 1.66699 17.5V4.16666C1.66699 3.70643 2.04009 3.33333 2.50033 3.33333H4.79199V2.20238C4.79199 1.90651 5.07181 1.66666 5.41699 1.66666C5.73341 1.66666 5.9949 1.8682 6.03629 2.12969L6.04199 2.20238V3.33333H13.9587V2.29166C13.9587 1.94649 14.2385 1.66666 14.5837 1.66666ZM17.0837 7.08333H2.91699V17.0833H17.0837V7.08333ZM13.3337 11.4583C13.6788 11.4583 13.9587 11.7382 13.9587 12.0833C13.9587 12.3997 13.7235 12.6612 13.4185 12.7026L13.3337 12.7083H6.66699C6.32181 12.7083 6.04199 12.4285 6.04199 12.0833C6.04199 11.7669 6.27712 11.5054 6.58218 11.464L6.66699 11.4583H13.3337ZM17.0837 4.58333H2.91699V5.83333H17.0837V4.58333Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }